import { Button, InputGroup } from '@vesyl/ui'
import { Box, Container, HStack, Icon, Input, RadioCard, Stack, Text } from '@vesyl/ui/chakra'
import { startCase } from 'lodash'
import { HiOutlineSparkles } from 'react-icons/hi2'
import {
  LuArrowRight,
  LuBuilding,
  LuHash,
  LuSheet,
  LuShoppingBag,
  LuShoppingCart,
  LuTag,
  LuUser,
  LuWeight,
} from 'react-icons/lu'
import { VesylLogo } from '@vesyl/ui'
import { Header } from '../../../next/components/header'

const mapping = [
  { icon: <LuHash />, field: 'Order Number', value: 'orderNumber', ai: true },
  { icon: <LuUser />, field: 'Name', value: 'toName', ai: true },
  { icon: <LuWeight />, field: 'Weight', value: 'parcelWeight', ai: true },
  { icon: <LuBuilding />, field: 'Company', value: 'toCompany' },
  { icon: <LuUser />, field: 'Line 1', value: 'toLine1' },
  { icon: <LuUser />, field: 'Line 2', value: 'toLine2' },
  { icon: <LuUser />, field: 'City', value: 'toCity' },
  { icon: <LuUser />, field: 'State', value: 'toState' },
  { icon: <LuUser />, field: 'Zip', value: 'toZip' },
]

const importTypes = [
  { type: 'orders', icon: <LuShoppingCart /> },
  { type: 'products', icon: <LuShoppingBag /> },
  { type: 'tags', icon: <LuTag /> },
]

export default function NewImport() {
  return (
    <Stack gap="4" h="full">
      <Header.Root>
        <Header.Left>
          <Header.Title>New import</Header.Title>
        </Header.Left>
      </Header.Root>

      <Container maxW="xl">
        <Stack gap="6">
          <Text fontSize="md" fontWeight="medium">
            What are you importing?
          </Text>

          <RadioCard.Root orientation="horizontal" size="sm">
            <HStack gap="3" align="stretch">
              {importTypes.map((t) => (
                <RadioCard.Item key={t.type} value={t.type}>
                  <RadioCard.ItemHiddenInput />
                  <RadioCard.ItemControl gap="1.5" alignItems="center">
                    <Icon fontSize="md" color="fg.muted">
                      {t.icon}
                    </Icon>
                    <RadioCard.ItemText>{startCase(t.type)}</RadioCard.ItemText>
                    <RadioCard.ItemIndicator />
                  </RadioCard.ItemControl>
                </RadioCard.Item>
              ))}
            </HStack>
          </RadioCard.Root>
        </Stack>

        <Stack mt="6" gap="6">
          <Text fontSize="md" fontWeight="medium">
            Map headers
          </Text>

          <Stack>
            <HStack gap="6" w="full">
              <HStack w="full">
                <LuSheet style={{ color: 'green' }} />
                <Text>CSV column headers</Text>
              </HStack>

              <HStack w="full" ml="12" gap="2">
                <VesylLogo variant="logomark" monochrome h="11px" />
                <Text>VESYL fields</Text>
              </HStack>
            </HStack>

            {mapping.map((m) => {
              return (
                <HStack gap="6" w="full" justifyContent="space-between" key={m.field}>
                  <Text color="fg.muted" w="full">
                    {m.value}
                  </Text>

                  <Box maxW="12" color="fg.muted">
                    <LuArrowRight />
                  </Box>

                  <HStack w="full">
                    <InputGroup startElement={m.icon} w="full">
                      <Input value={m.field} />
                    </InputGroup>
                    <Box w="5">{m.ai && <HiOutlineSparkles style={{ color: '#6A1B9A' }} />}</Box>
                  </HStack>
                </HStack>
              )
            })}
          </Stack>
        </Stack>

        <HStack mt="8">
          <Button ml="auto" size="sm" w="fit">
            Import
          </Button>
        </HStack>
      </Container>
    </Stack>
  )
}
